import { ref, reactive, computed } from 'vue'
import { useStore } from 'vuex'
import { t } from '@/plugins/i18n'

import {
  intShipConfigList,
  getEstimateIntShip,
  getAdditionalLabel,
  getListByType
} from '@/apis/inShipping'
import { ElMessage } from 'element-plus'
export default () => {
  const store = useStore()
  const form: any = reactive({
    customerShopId: store.getters.curShop,
    customerShopName: store.getters.shopname,
    customerName: store.getters.user.customerName,
    customerId: store.getters.user.customerId,
    deliveryAdditionalList: [],
    declarationAddress: {},
    receiverAddress: {},
    receiverEnglishAddress: {},
    deliverTaskDetails: [],
    deliveryTitle: '',
    deliveryNums: 0,
    isOversea: false,
    boxMarkLink: '',
    intShipConfigId: null,
    intForwarderConfigId: null,
    forwarder: null,
    shippingType: null,
    warehouse: '',
    deliveryType: 1,
    distribution: null,
    labelTemplateId: ''
  })
  const rules = {
    deliveryTitle: [{ required: true, message: t('国际发货标题不能为空'), trigger: 'blur' }],
    intShipConfigId: [{ required: true, message: t('物流方式不能为空'), trigger: 'blur' }],
    boxMarkLink: [
      {
        validator: (rule: any, val: string, callback: any) => {
          if (!hasMarkAdditionId.value) {
            callback()
          } else {
            if (val) {
              callback()
            } else {
              callback(t('箱唛上传不能为空'))
            }
          }
        },
        trigger: 'change'
      }
    ],
    labelTemplateId: [
      {
        validator: (rule: any, val: string, callback: any) => {
          if (!hasLabelAdditionId.value) {
            callback()
          } else {
            if (val) {
              callback()
            } else {
              callback(t('必填'))
            }
          }
        },
        trigger: 'change'
      }
    ],
    deliverTaskDetails: {
      deliveryNums: [{
        validator: (rule: any, val: any, callback: any) => {
          if (Number(val) > 0) {
            callback()
          } else {
            callback(t('必填'))
          }
        },
        trigger: 'blur'
      }]
    }
  }

  // const templateOption = ref([])
  const templatePreview: any = ref('')
  // getListByType().then((res: any) => {
  //   if (res.success) {
  //     templateOption.value = res.data
  //   }
  // })

  const hasMarkAdditionId: any = computed(() => {
    const hasSelectAddition = form.deliveryAdditionalList.findIndex((e: { additionCode: any; }) => String(e.additionCode) === additionalLabelDict.value.need_mark_delivery_addition_id)
    return hasSelectAddition !== -1
  })

  const hasLabelAdditionId: any = computed(() => {
    const hasSelectAddition = form.deliveryAdditionalList.findIndex((e: { additionCode: any; }) => String(e.additionCode) === additionalLabelDict.value.need_label_delivery_addition_id)
    return hasSelectAddition !== -1
  })

  const formRef = ref()

  const weight = ref()
  const estimateIntShip = ref(0)
  const getEstimateIntShipInfo = () => {
    if (!form.intShipConfigId) {
      ElMessage.warning(t('国际物流配置id不能为空'))
      return
    }
    getEstimateIntShip({
      intShipConfigId: form.intShipConfigId,
      weight: weight.value
    }).then(res => {
      estimateIntShip.value = res.data?.estimateIntShipFee
    })
  }

  const changePrice: any = (row: any) => {
    const num = row.deliveryNums.toString().match(/^\d*(\.?\d{0,2})/g)[0]
    row.deliveryNums = num ? Math.min(num, (row.useable || 0)) : ''
  }

  const inputPrice: any = (row: any) => {
    const num = row.deliveryNums.toString().match(/^\d*(\.?\d{0,2})/g)[0]
    row.deliveryNums = num
  }

  const setFile = (file: { raw: { url: string } }) => {
    form.boxMarkLink = file?.raw.url || ''
  }

  const additionalLabelDict: any = ref({})
  getAdditionalLabel().then((res) => {
    (res.data || []).forEach((e: { dictKey: string | number; dictValue: any; }) => {
      additionalLabelDict.value[e.dictKey] = e.dictValue?.split(',')?.[0]
    })
  })

  // const intShipTypeOption: any = ref([])
  // intShipConfigList({ systemSource: store.getters.plat === 'd2c' ? 1 : 2 }).then(res => {
  //   intShipTypeOption.value = res.data
  // })
  // const intShipType = computed({
  //   get: () => form.intShipConfigId,
  //   set: (v) => {
  //     const t = intShipTypeOption.value.find((e: { intShipConfigId: string }) => e.intShipConfigId === v)
  //     form.intShipConfigId = v
  //     form.intForwarderConfigId = t.forwarder?.intForwarderConfigId
  //     form.distribution = t.distribution
  //     form.forwarder = t.forwarder?.forwarder
  //     form.shippingType = t.forwarder?.shippingType
  //   }
  // })

  return {
    form,
    rules,
    formRef,
    weight,
    estimateIntShip,
    getEstimateIntShipInfo,
    changePrice,
    inputPrice,
    setFile,
    additionalLabelDict,
    // intShipTypeOption,
    // intShipType,
    hasMarkAdditionId,
    hasLabelAdditionId,
    // templateOption,
    templatePreview
  }
}
